import React, { useState, useEffect } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import axios from "axios";
import { useNavigate, Link } from 'react-router-dom'
import Swal from 'sweetalert2';
import Carousel from "./carousel/carousel";
import Map from './map/map';
import { createSelector } from 'reselect';
import { feet2ToMeter2, feetToMeter } from '../constants/constants';
import { formatDate } from "../../utils/dateFormatter";

const feetSelector = createSelector(
  store => store.feets,
  feets => feets
);


const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`);

const PaymentForm = () => {
  const navigate = useNavigate();
  const userEmail = useSelector(state => state.user.email);
  const stripe = useStripe();
  const elements = useElements();
  const [clientSecret, setClientSecret] = useState('');
  const [orderId, setOrderId] = useState('');
  const [isPreparingPayment, setIsPreparingPayment] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);



  var addPayment = localStorage.getItem('add_payment');
  var addPaymentObject = JSON.parse(addPayment);
  if (!addPayment) {
    navigate('/view-contract');
  }

  useEffect(() => {
    async function prepareInitialPayment() {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}stripe.php`, {
          action: 'GarageAddPayment',
          datebaseid: addPaymentObject,
        });

        if (response.data.status !== true) {
          Swal.fire('Payment unavailable', response.data.message || 'Unable to prepare the payment.', 'error');
          navigate('/view-contract');
          return;
        }

        setClientSecret(response.data.clientSecret);
        setOrderId(response.data.order_id);
        localStorage.setItem('orderId', JSON.stringify(response.data.order_id));
      } catch (error) {
        console.error('Error preparing garage payment:', error);
        Swal.fire('Payment unavailable', 'Unable to prepare the initial payment.', 'error');
        navigate('/view-contract');
      } finally {
        setIsPreparingPayment(false);
      }
    }

    if (addPaymentObject) {
      prepareInitialPayment();
    }
  }, [addPaymentObject, navigate]);





  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements || !clientSecret || !orderId) {
      return;
    }

    setIsSubmitting(true);

    Swal.fire({
      title: 'Payment Processing, please wait',
      html:
        '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
      showConfirmButton: false,
      showCancelButton: false,
      focusConfirm: false,
      allowOutsideClick: false,
    });

    const cardElement = elements.getElement(CardElement);
    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          email: userEmail,
        },
      },
    });

    if (error) {
      Swal.close();
      setIsSubmitting(false);
      Swal.fire(error.code || 'Payment failed', error.message, 'error');
      console.error(error);
      return;
    }

    if (!paymentIntent || paymentIntent.status !== 'succeeded') {
      Swal.close();
      setIsSubmitting(false);
      Swal.fire('Payment incomplete', 'The initial payment did not complete successfully.', 'error');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}`, {
        action: 'UpdateGaragePaymentStatus',
        order_id: orderId,
      });

      const subscriptionResponse = await axios.post(`${process.env.REACT_APP_API_URL}stripe.php`, {
        action: 'GarageCreateRecurringSubscription',
        datebaseid: addPaymentObject,
        payment_method_id: paymentIntent.payment_method,
      });

      if (subscriptionResponse.data.status === true) {
        Swal.close();
        Swal.fire('Payment successful', 'The deposit has been charged and the monthly subscription is scheduled.', 'success')
          .then(() => {
            navigate('/view-contract');
          });
      } else {
        Swal.close();
        Swal.fire(
          'Initial payment succeeded',
          subscriptionResponse.data.message || 'The monthly subscription was not scheduled. Please contact support before charging the renter again.',
          'warning'
        );
      }
    } catch (requestError) {
      Swal.close();
      console.error('Error finalizing garage payment:', requestError);
      Swal.fire(
        'Initial payment succeeded',
        'The monthly subscription setup could not be completed automatically. Please contact support before retrying payment.',
        'warning'
      );
    } finally {
      setIsSubmitting(false);
    }

  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        required
      /> */}
      <CardElement />
      <button className="btn btn-primary btn-lg mt-3" type="submit" disabled={!stripe || isPreparingPayment || isSubmitting || !clientSecret}>
        {isPreparingPayment ? 'Preparing payment...' : (isSubmitting ? 'Processing...' : 'Pay now')}
      </button>
    </form>
  );
};

export default function PaymentGarage() {
  const navigate = useNavigate();


  const [imagesURLs, setImagesURLs] = useState([]);
  const [sampleContract, setSampleContract] = useState();
  const [garageInsurance, setGarageInsurance] = useState();
  const [item, setItem] = useState({});

  const [metricUnit, setMetricUnit] = useState('');
  const feets = useSelector(feetSelector);
  useEffect(() => {
    setMetricUnit(() => {
      if (feets)
        return 'ft';
      return 'm';
    })
  }, [feets]);

  var addPayment = localStorage.getItem('add_payment');
  var addPaymentObject = JSON.parse(addPayment);
  if (!addPayment) {
    navigate('/view-contract');
  }


  useEffect(() => {
    async function getGarage() {
      const data = await axios.post(`${process.env.REACT_APP_API_URL}`,
        { action: 'GetContractDetailsbyContractId', id: addPaymentObject })
        .then(response => {
          if (response.data.status === true) {
            console.log('response.data.data',response.data.data)
            return response.data.data;
          } else {
            Swal.fire({
              icon: 'info',
              title: response.data.message,
            });
            navigate('/')
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });

      if (data.sampleContractURL) {
        setSampleContract(() => {
          return process.env.REACT_APP_UPLOAD_URL + data?.contractDetails?.sign_contract;
        })
      }

      if (data.garageInsuranceURL) {
        setGarageInsurance(() => {
          return process.env.REACT_APP_UPLOAD_URL + data.garageInsuranceURL;
        })
      }

      const urlsArray = data.garagePictures;
      const garagePicturesAngle = data.garagePicturesA;
      let imagesURL = [];

      if (urlsArray.length > 0) {
        urlsArray.forEach((element, index) => {
          const timestamp = format(new Date(), 'MMddyyyyHis');
          const rotatedImage = {
            url: process.env.REACT_APP_UPLOAD_URL + element + '?timestamp=' + timestamp,
            rotationAngle: garagePicturesAngle[index] ? garagePicturesAngle[index] : '', // Fix: Use index to access the corresponding rotation angle
          };
          setImagesURLs([...imagesURL, rotatedImage])
          imagesURL = [...imagesURL, rotatedImage];
        });


      } else {
        imagesURL = [{
          url: './assets/Images/garage-placeholder.png',
          rotationAngle: 0, // Set a default rotation angle if needed
        }];
      }

      setItem((prev) => (
        {
          ...prev,
          ...data,
          imgs: imagesURL,
        }
      ));
    }

    if (addPaymentObject) {
      getGarage(addPaymentObject);
    }
  }, [addPaymentObject]);

  const [maplatlng, setMaplatlng] = useState();
  function handleShowMap(e) {
    e.preventDefault();
    const latlng = { coordinates: { latitude: item.lat, longitude: item.lon }, address: item.address }
    console.log('latlng', latlng)
    setMaplatlng(latlng);
    document.getElementById('imagePreviewModal').classList.add('show');
    document.getElementById('imagePreviewModal').style.display = 'block';
  }
  const closeModal = (event) => {
    event.preventDefault();
    // setPreviewImages([]);
    document.getElementById('imagePreviewModal').classList.remove('show');
    document.getElementById('imagePreviewModal').style.display = 'none';
  };

  const openPDFModal = (event) => {
    event.preventDefault();
    document.getElementById('pdfPreviewModal').classList.add('show');
    document.getElementById('pdfPreviewModal').style.display = 'block';
  };

  const closePDFModal = (event) => {
    event.preventDefault();
    document.getElementById('pdfPreviewModal').classList.remove('show');
    document.getElementById('pdfPreviewModal').style.display = 'none';
  };

  const openPDFTwoModal = (event) => {
    event.preventDefault();
    document.getElementById('pdfPreviewModalTwo').classList.add('show');
    document.getElementById('pdfPreviewModalTwo').style.display = 'block';
  };

  const closePDFTwoModal = () => {
    document.getElementById('pdfPreviewModalTwo').classList.remove('show');
    document.getElementById('pdfPreviewModalTwo').style.display = 'none';
  };


  return (
    <section className="page-content half-map sec-padding">
      <div className="container">
        <div className="sec-title row justify-content-center">
          <h3>Payment</h3>
        </div>
        <div className="col-md-12 mx-auto">
          <div className="row AddressView">
            <div className="col-md-6">

              <h3>Garage Details</h3>


              <table className='table garagedetailTable'>
                <tbody>

                  <tr>
                    <td><i className='fa fa-location-arrow strong'></i></td>
                    <td> <span className='strong'>Neighborhood: </span></td>
                    <td>{item.neighborhood}</td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td><i className='fa fa-location-arrow strong'></i></td>
                    <td> <span className='strong'>Zipcode: </span></td>
                    <td>{item.zipcode}</td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td><i className='fa fa-home strong'></i></td>
                    <td><span className='strong'>Dimensions: </span></td>
                    <td>   <div>
                      <small className='small'>length: </small>
                      <span>{item && `${feets ? item.length : feetToMeter(item.length, true)} ${metricUnit}`}</span>
                    </div>

                      <div>
                        <small className='small'>width: </small>
                        <span>{item && `${feets ? item.width : feetToMeter(item.width, true)} ${metricUnit}`}</span>
                      </div>

                      <div>
                        <small className='small'>area: </small>
                        <span>{item && `${feets ? (item.width * item.length) : feet2ToMeter2((item.width * item.length), true)} ${metricUnit}²`}</span>
                      </div></td>
                    <td></td>
                    <td></td>
                  </tr>


                  <tr>
                    <td><i className='fa fa-lock strong'></i></td>
                    <td><span className='strong'>Main Door:</span></td>
                    <td>     <div>
                      <small className='small'>height: </small>
                      <span>{item && `${feets ? item.mainDoorHeight : feetToMeter(item.mainDoorHeight, true)} ${metricUnit}`}</span>
                    </div>
                      <div>
                        <small className='small'>width: </small>
                        <span>{item && `${feets ? item.mainDoorWidth : feetToMeter(item.mainDoorWidth, true)} ${metricUnit}`}</span>
                      </div></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td><i className='fa fa-lock strong'></i></td>
                    <td><span className='strong'>Connected to the house:</span></td>
                    <td>{item && item.isConnectedToHouse == 'true' ? 'Yes' : 'No'}</td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td><i className='fa fa-lock strong'></i></td>
                    <td><span className='strong'>Door Opener:</span></td>
                    <td>{item && item.doorOpener == 'true' ? 'Yes' : 'No'}</td>
                    <td></td>
                    <td></td>
                  </tr>


                  <tr>
                    <td><i className='fa fa-dollar strong'></i></td>
                    <td><span className='strong'>Drywalled:</span> </td>
                    <td>{item && item.drywalled == 'true' ? 'Yes' : 'No'}</td>
                    <td></td>
                    <td></td>
                  </tr>


                  <tr>
                    <td><i className='fa fa-lock strong'></i></td>
                    <td><span className='strong'>Electrical Outlets:</span></td>
                    <td> <div>
                      <small className='small'>110V: </small>
                      <span>{(item && item.electricalOutlets110V && item.electricalOutlets110V == 'true') ? 'true' : 'false'}</span>
                    </div>

                      <div>
                        <small className='small'>220V: </small>
                        <span>{(item && item.electricalOutlets220V && item.electricalOutlets220V == 'true') ? 'true' : 'false'}</span>
                      </div></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td><i className='fa fa-plug strong'></i></td>
                    <td><span className='strong'>Other Storage:</span></td>
                    <td>{item && item.otherStorage == 'true' ? 'Yes' : 'No'}</td>
                    <td></td>
                    <td></td>
                  </tr>


                  <tr>
                    <td><i className='fa fa-dollar strong'></i></td>
                    <td><span className='strong'>Side Door:</span> </td>
                    <td>{item && item.sideDoor == 'true' ? 'Yes' : 'No'}</td>
                    <td></td>
                    <td></td>
                  </tr>


                  <tr>
                    <td><i className='fa fa-windows strong'></i></td>
                    <td><span className='strong'>Windows:</span></td>
                    <td>{item && item.windows == 'true' ? 'Yes' : 'No'}</td>
                    <td></td>
                    <td></td>
                  </tr>


                  <tr>
                    <td><i className='fa fa-snowflake-o strong'></i></td>
                    <td><span className='strong'>Heated / AC:</span></td>
                    <td>{item && (item.heated || 'No')}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>


              {sampleContract &&
                <div className="modal fade" id="pdfPreviewModal" tabIndex="-1" role="dialog">
                  <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Sample Contract Preview</h5>

                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closePDFModal}>
                          <span aria-hidden="true"></span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <embed src={sampleContract} type="application/pdf" width="100%" height="500px" />
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFModal}>Close</button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              {garageInsurance &&
                <div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog">
                  <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Garage Insurance Preview</h5>

                        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closePDFTwoModal}>
                          <span aria-hidden="true"></span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <embed src={garageInsurance} type="application/pdf" width="100%" height="500px" />
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFTwoModal}>Close</button>
                      </div>
                    </div>
                  </div>
                </div>
              }

              <div className='btn-toolbar'>
                {sampleContract ?
                  <button onClick={openPDFModal} className='btn btn-primary btn-lg' target="_blank" rel="noopener noreferrer">Signed Contract</button>
                  :
                  <button onClick={() => Swal.fire({ icon: 'question', title: 'There\'s no sample contract in this garage' })} className='btn btn-primary' >Signed contract</button>
                }
                {garageInsurance ?
                  <button onClick={openPDFTwoModal} className='btn btn-primary btn-lg' target="_blank" rel="noopener noreferrer">Garage Insurance</button>
                  :
                  <button onClick={() => Swal.fire({ icon: 'question', title: 'There\'s no sample contract in this garage' })} className='btn btn-primary' >Garage Insurance</button>
                }


              </div>

              <div className="row">
                {imagesURLs &&
                  <Carousel images={imagesURLs} />
                }

              </div>


            </div>
            <div className="col-md-6">


              <table className='table'>
                <tbody>
                  <tr>
                    <td><span className='strong'>Address: </span></td>
                    <td> <div>{item.address} , {item.city}, {item.state}</div>

                    </td>
                    <td>
                      <button className='btn btn-primary' onClick={handleShowMap}>
                        Map
                      </button>
                      <div className="modal fade" id="imagePreviewModal" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Map Preview</h5>
                              <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                                <span aria-hidden="true"></span>
                              </button>
                            </div>
                            <div className="modal-body" style={{ height: "500px", overflowY: "auto" }}>

                              <div className="row align-items-center">
                                {maplatlng &&
                                  <Map
                                    type="point"
                                    extraInfo={maplatlng}
                                  />
                                }
                              </div>
                            </div>

                            <div className="modal-footer">
                              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closeModal}>Done</button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </td>

                  </tr>
                  <tr>
                    <td><span className='strong'>Start Date:</span></td>
                    <td colSpan={2}> {item?.contractDetails?.startdate ? formatDate(item?.contractDetails?.startdate) : 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><span className='strong'>End Date:</span></td>
                    <td colSpan={2}>{item?.contractDetails?.enddate ? formatDate(item?.contractDetails?.enddate) : 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><span className='strong'>Number of months:</span></td>
                    <td colSpan={2}>{item?.contractDetails?.noofmonths ?? 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><span className='strong'>Rental Payment:</span></td>
                    <td colSpan={2}>${item?.contractDetails?.rentalRate ?? 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><span className='strong'>Security Deposit:</span></td>
                    <td colSpan={2}>${item?.contractDetails?.deposit ?? 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><span className='strong'>Initial Charge Today:</span></td>
                    <td colSpan={2}>${item?.contractDetails?.deposit ?? 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><span className='strong'>Next Monthly Charge:</span></td>
                    <td colSpan={2}>${item?.contractDetails?.rentalRate ?? 'N/A'}</td>
                  </tr>



                </tbody>
              </table>



              <Elements stripe={stripePromise}>
                <p className="text-muted">
                  Today's charge collects the security deposit. The monthly rent is scheduled separately so the renter is not charged all remaining months up front.
                </p>
                <PaymentForm />
              </Elements>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
